































































import { computed, defineComponent, ref } from '@vue/composition-api';
import copy from 'clipboard-copy';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import { useCreateApiKey } from '@/store/modules/apiKeys';
import { isNotEmpty } from '@/utils/rules';

export default defineComponent({
	components: { ConfirmDialog },
	inheritAttrs: false,
	setup(_, { root }) {
		const showConfirmationDialog = ref<boolean>(false);
		const form = ref();
		const label = ref<string>('');
		const apiKey = ref<string>('');
		const isCopied = ref<boolean>(false);
		const { createApiKey, clearError, isLoading, hasError, error: createError } = useCreateApiKey(root.$store);

		const error = computed<string>(
			() =>
				createError.value?.response?.data?.message ||
				'An error occurred while attempting to generate an API key. Please try again.'
		);

		const handleConfirmCopy = () => {
			showConfirmationDialog.value = false;
		};

		const handleConfirmGenerate = async (event: any) => {
			if (apiKey.value.length === 0) {
				event?.preventDefault();
				clearError();

				if (!form.value.validate()) {
					return;
				}

				apiKey.value = await createApiKey(label.value.trim());
			} else {
				handleConfirmCopy();
			}
		};

		const handleCopy = () => {
			isCopied.value = false;

			copy(apiKey.value)
				.then(() => {
					isCopied.value = true;
				})
				.finally(() => {
					setTimeout(() => {
						isCopied.value = false;
					}, 2500);
				});
		};

		const handleCleanup = () => {
			root.$store.dispatch('user/getUser');
			form.value?.reset();
			label.value = '';
			apiKey.value = '';
			isCopied.value = false;
			clearError();
		};

		return {
			showConfirmationDialog,
			label,
			apiKey,
			isCopied,
			handleConfirmGenerate,
			handleConfirmCopy,
			handleCopy,
			handleCleanup,
			isLoading,
			hasError,
			error,
			isNotEmpty,
			form,
		};
	},
});
